import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'reference', label: 'Reference' },
  { key: 'member_name', label: 'Member' },
  { key: 'claim_type', label: 'Claim Type' },
  { key: 'status', label: 'Stage' },
  { key: 'calculated_entitlement', label: 'Entitlement', align: 'right', type: 'money' },
  { key: 'days_in_stage', label: 'Days in Stage', align: 'right' },
];

export function ClaimsByStageReport() {
  return (
    <ReportView
      title="Benefit Claims in Progress by Stage"
      description="Every benefit claim not yet disbursed, reversed, or closed, grouped by its current stage."
      endpoint="/reports/benefits/claims-by-stage"
      columns={COLUMNS}
    />
  );
}
